module.exports = __webpack_public_path__ + "img/全屏.6c9e03ac.svg";